export default "__VITE_ASSET__3c7f62b8__"